<div class="tab-content">
  <div class="table-view">
    <!-- Table starts -->
    <p-table styleClass="kuba-project-table" [tableStyle]="{ minWidth: '80rem', tableLayout: 'fixed' }"
      [value]="projects"
      #projectsTable
      [rows]="10"
      [paginator]="true"
      [pageLinks]="3"
      [rowsPerPageOptions]="[5, 10, 20]"
      exportFilename="AllProjectsList"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'SUMMARY_TOTALRECORDS' | translate }}"
    >
      <!-- Caption -->
      <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix">
          <div class="filter-controls-wrapper" style="display: none">
            <div class="row">
              <div class="col-sm-3">
                <div class="form-group">
                  <label for="Course" class="col-form-label" translate
                    >PROJ_RESPONS
                  </label>
                  <div>
                    <p-select
                      [options]="ProjectResponsibility"
                      #responsibleDropdown
                      (onChange)="
                        onResponsibleChanged($event, responsibleDropdown)
                      "
                      [filter]="true"
                    ></p-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-options">
            <div class="pull-right">
              <div class="action-btns-group">
                <button class="btn btn-secondary filter-toggle">
                  <span class="icon ic-sm icon-filter"></span>
                  <span translate>FILTER</span>
                </button>
              </div>
              <div class="action-btns-group" *ngIf="guestLogin">
                <kuba-export
                  [reportData]="
                    projectsTable.filteredValue || projectsTable.value
                  "
                  [additionalData]="additionalData"
                ></kuba-export>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <!-- Header -->
      <ng-template pTemplate="header">
        <tr>
          <th class="kuba-column-number" pSortableColumn="Number">
            {{ "NR" | translate }}
            <p-sortIcon field="Number"></p-sortIcon>
          </th>
          <th class="kuba-column-title" pSortableColumn="Title">
            {{ "PROJ_NAME" | translate }}
            <p-sortIcon field="Title"></p-sortIcon>
          </th>
          <th class="kuba-column-date" pSortableColumn="StartDate">
            {{ "START_DATE" | translate }}
            <p-sortIcon field="StartDate"></p-sortIcon>
          </th>
          <th class="kuba-column-date" pSortableColumn="ExpectedEndDate">
            {{ "END_DATE" | translate }}
            <p-sortIcon field="ExpectedEndDate"></p-sortIcon>
          </th>
          <th pSortableColumn="ProjectManagers">
            {{ "PROJ_MANAGER" | translate }}
            <p-sortIcon field="ProjectManagers"></p-sortIcon>
          </th>
          <th>{{ "STATUS" | translate }}</th>

          <th class="kuba-column-image" pSortableColumn="ProjectImage">
            {{ "IMAGE" | translate }}
            <p-sortIcon field="ProjectImage"></p-sortIcon>
          </th>
          <th pSortableColumn="CreatorName">
            {{ "CREATED_BY" | translate }}
            <p-sortIcon field="CreatorName"></p-sortIcon>
          </th>
          <th pSortableColumn="ModifierName">
            {{ "EDITED_BY" | translate }}
            <p-sortIcon field="ModifierName"></p-sortIcon>
          </th>
          <th>{{ "OPTIONS" | translate }}</th>
        </tr>
        <tr>
          <th>
            <input
              pInputText
              type="text"
              (input)="
                projectsTable.filter(
                  $any($event.target)?.value,
                  'Number',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th>
            <input
              pInputText
              type="text"
              (input)="
                projectsTable.filter(
                  $any($event.target)?.value,
                  'Title',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th>
            <p-select
              [options]="statuses"
              (onChange)="onStatusChanged($event, statusDropdown)"
              #statusDropdown
              styleClass="p-column-filter"
              placeholder="Select"
              appendTo="body"
              [showClear]="true"
            >
              <ng-template let-status pTemplate="item">
                {{ status.label | translate }}
              </ng-template>
            </p-select>
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <!-- Body Content -->
      <ng-template pTemplate="body" let-project>
        <tr>
          <td
            style="
              width: 80px;
              min-width: 50px;
              max-width: 150px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            "
          >
            <span>{{ project.Number }}</span>
          </td>
          <td style="width: auto; min-width: 250px">
            <a
              [routerLink]="['./../../details', project.Id]"
              pTooltip="{{ project.Title }}"
              tooltipPosition="top"
              >{{ project.Title }}</a
            >
          </td>
          <td style="width: 110px">
            <span>{{ project.StartDate | date: "dd/MM/yyyy" }}</span>
          </td>
          <td style="width: 110px">
            <span>{{ project.ExpectedEndDate | date: "dd/MM/yyyy" }}</span>
          </td>
          <td>
            <span>{{ project.ProjectManagers }}</span>
          </td>
          <td style="width: 50px">
            <span>{{ project.Status | translate }}</span>
          </td>

          <td style="text-align: center; vertical-align: middle">
            <img
              *ngIf="project.ProjectImage"
              src="{{ project.ProjectImage }}"
              alt=""
              width="100"
              height="100"
              class="thumbnail"
              style="display: block; margin: 0 auto"
            />
          </td>

          <td>
            <span>{{ project.CreatorName }}</span>
          </td>
          <td>
            <span>{{ project.ModifierName }}</span>
          </td>
          <td class="col-button" style="width: 80px">
            <button
              type="button"
              [routerLink]="['./../../edit', project.Id]"
              title="{{ 'EDIT' | translate }}"
            [attr.aria-label]="'EDIT' | translate" class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row">
            <i class="pi pi-pencil"></i>
          </button>
            <button
              type="button"
              (click)="deleteProject(project)"
              title="{{ 'DELETE' | translate }}"
              *ngIf="isHideDeleteIcon"
            [attr.aria-label]="'DELETE' | translate" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
          </td>
        </tr>
      </ng-template>

      <!-- Empty message -->
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td colspan="10">
            {{ "NO_RECORDS_FOUND" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
    <!-- Table ends -->
  </div>
</div>

<p-dialog
  header="{{ 'INFORMATION' | translate }}"
  [(visible)]="isAdminProject"
  [modal]="true"
  width="300"
>
  You do not have rights to Perform this action.
  <ng-template pTemplate="footer">
    <button
      type="button"
      class="btn btn-link"
      title="{{ 'OK' | translate }}"
      (click)="informationHide()"
    >
      Ok
    </button>
  </ng-template>
</p-dialog>
<p-confirmDialog
  header="{{ 'CONFIRMATION' | translate }}"
  icon="pi pi-question-circle"
  width="425"
  acceptLabel="{{ 'SWITCH_YES' | translate }}"
  rejectLabel="{{ 'SWITCH_NO' | translate }}"
></p-confirmDialog>
